module.exports = __webpack_public_path__ + "img/tree.e133e7b9.svg";